<template>
    <div id="developer" class="container-fluid">
        <p>
            <span class="about-img">
                <img src="../assets/img/me.jpg" />
            </span>
            <span class="aboutdeveloper" id="text-logo">
                My name is Okiemute Gold. <br />
                A passionate technology enthusiast and an experienced Frontend
                developer, with interests in Product Management and Social
                Innovation.
                <br />
                <br />Okiemute is skilled in/using Semantic HTML, Web
                Accesibility, Responsive Web Design, CSS, Bootstrap, JavaScript,
                jQuery , Vue. And has good knowledge of Digital Marketing, User
                Experience, and Product Management.
                <br />
                <br />He is a 'self-taught' Frontend developer with interest in
                building user-friendly websites to help companies promote their
                products.
                <br />
                <br />He thrives on challenges, innovating through to provide
                solutions relevant to life problems.
                <br />
                <br />
                He thinks, plays scrabble, soccer games, and teaches when he is
                not coding.
            </span>
        </p>
        <div class="contact_me">
            <h4>Connect to me</h4>
            <div class="buttons">
                <a
                    href="mailto:goldokiemute@gmail.com"
                    class="contact_me_btn email"
                >
                    <i class="fa fa-envelope-o mr-2"></i>
                    E-mail me
                </a>
                <a
                    href="https://github.com/OkiemuteGold"
                    class="contact_me_btn github"
                >
                    <i class="fa fa-github mr-2"></i>
                    Github
                </a>
                <a
                    href="https://www.linkedin.com/in/okiemute-gold"
                    class="contact_me_btn linkedin"
                >
                    <i class="fa fa-linkedin mr-2"></i>
                    LinkedIn
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Developer",
};
</script>

<style>
</style>